// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"a8ed2c78","453":"bfd56f49","958":"61c3c56d"}[chunkId] + ".chunk.js";
};